import { GET, POST, PUT, DELETE } from '../apiController';

const ORG_USER_DASHBOARD = '/user/userdashboard';

// ---------------------------------------------------------------------------
// Activity logs (user dashboard)
// ---------------------------------------------------------------------------

export const getUserLogs = (data = { page: 1, limit: 20 }) => {
  return POST(`${ORG_USER_DASHBOARD}/get_user_logs`, data);
};

// ---------------------------------------------------------------------------
// Dashboard stats & performance
// ---------------------------------------------------------------------------

export const getTraineeStats = () => {
  return GET(`${ORG_USER_DASHBOARD}/user_dashboard_status`);
};

export const getDashboardMonthlyPerformance = () => {
  return GET(`${ORG_USER_DASHBOARD}/dashboard_performance`);
};

// ---------------------------------------------------------------------------
// Task list (classroom tasks)
// ---------------------------------------------------------------------------

export const getTaskLists = (data) => {
  return POST(`${ORG_USER_DASHBOARD}/get_task_lists`, data);
};

export const markTaskAsSeen = (data) => {
  return PUT(`${ORG_USER_DASHBOARD}/mark_task_as_seen`, data);
};

// ---------------------------------------------------------------------------
// Todo list (user's own tasks)
// ---------------------------------------------------------------------------

export const getAllTasksByUser = () => {
  return GET(`${ORG_USER_DASHBOARD}/get_all_tasks`);
};

export const addTask = (data) => {
  return POST(`${ORG_USER_DASHBOARD}/add_task`, data);
};

export const editTaskById = (data) => {
  return PUT(`${ORG_USER_DASHBOARD}/edit_task`, data);
};

export const deleteTaskById = (task_id) => {
  return DELETE(`${ORG_USER_DASHBOARD}/delete_task?task_id=${task_id}`);
};

export const markTaskAsCompleted = (data) => {
  return PUT(`${ORG_USER_DASHBOARD}/mark_task_as_completed`, data);
};

// ---------------------------------------------------------------------------
// Gamification
// ---------------------------------------------------------------------------

export const getAllGamificationData = () => {
  return GET('/mainOrg/gamification/data');
};

export const getPointsActivity = (limit = 20) => {
  return GET('/mainOrg/gamification/points-activity', { limit });
};

export const getAllGamificationLevels = () => {
  return GET('/mainOrg/gamification/levels');
};

export const getCurrentLevelProgress = () => {
  return GET('/mainOrg/gamification/level-progress');
};

export const getAllBadges = () => {
  return GET('/mainOrg/gamification/badges');
};

export const getUserBadges = () => {
  return GET('/mainOrg/gamification/user-badges');
};

export const getLeaderboard = () => {
  return GET('/mainOrg/gamification/leaderboard');
};

